import React, { useState, useEffect } from 'react';
import ApiService from '../services/api';
import {
    MonitorCog , SquareActivity , Tickets ,Receipt ,
    Menu,
    X,
    Home,
    Package,
    FileText,
    Calendar,
    Users,
    BarChart3,
    Settings,
    Bell,
    Search,
    ChevronDown,
    ArrowRight,
    TrendingUp,
    TrendingDown,
    Building,
    Hammer,
    Truck,
    Star,
    AlertCircle,
    CheckCircle,
    Clock,
    DollarSign,
    Activity,
    Globe,
    Zap,
    Target,
    Award,
    Shield,
    LogOut,
    ChevronRight,
    Filter,
    Download,
    RefreshCw,
    MoreVertical,
    Plus,
    User,
    Edit,
    Trash2,
    Eye,
    Upload,
    UserCheck,
    UserX,
    Calendar as CalendarIcon,
    PieChart,
    BarChart,
    Percent,
    Timer,
    MapPin,
    Coffee,
    PlayCircle,
    PauseCircle,
    ArrowLeft,
    ChevronUp,
    Cable,
    Lock,
    UserPlus,
    Save,
    EyeOff,
    Key,
    Unlock,
    Users as UsersIcon,
    AlertTriangle,
    Mail,
    Phone,
    MapPinIcon,
    Briefcase,
    UserCog,
    Calculator,
    Construction,
    Beaker,
    Leaf,
    ShieldCheck,
    Wrench,
    Folder
} from 'lucide-react';
import '../Styles/products.css';
import { useNavigate } from 'react-router-dom';
import MepIcon from '../assets/MEP_Solutions.png';
import architecturalIcon from '../assets/architectural_icon.png';
import civilIcon from '../assets/civil-icon.png';
import constructionIcon from '../assets/construction-icon.png';
import powerToolsIcon from '../assets/power-tools_icon.png';
import sustainableIcon from '../assets/sustainable-icon.png';
import hygienicIcon from '../assets/hygienic-icon.png';
import '../Styles/dashboard.css';

const UserManagementPage = () => {
    const [user, setUser] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('user-management');
    const [currentTime, setCurrentTime] = useState(new Date());
    const navigate = useNavigate();

    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [passwordInput, setPasswordInput] = useState('');
    const [showPasswordError, setShowPasswordError] = useState(false);
    const ADMIN_PASSWORD = 'admin2024';

    const [users, setUsers] = useState([]);
    const [totalUsers, setTotalUsers] = useState(0);
    const [userStats, setUserStats] = useState({
        total: 0,
        active: 0,
        inactive: 0,
        admins: 0,
        managers: 0,
        employees: 0
    });

    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
    const [userToDelete, setUserToDelete] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showPasswords, setShowPasswords] = useState({});

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        role: 'user',
        department: '',
        position: '',
        phone: ''
    });

    const [searchTerm, setSearchTerm] = useState('');
    const [filterRole, setFilterRole] = useState('all');
    const [filterStatus, setFilterStatus] = useState('all');
    const [page, setPage] = useState(1);
    const [limit] = useState(20);

    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            setTimeout(() => {
                loadUsers();
            }, 100);
        }
    }, [isAuthenticated, searchTerm, filterRole, filterStatus, page]);

    const loadCurrentUser = async () => {
        try {
            const response = await ApiService.getCurrentUser();
            if (response.success) {
                setUser(response.user);
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        }
    };

            const handleRefresh = () => {
        showNotification('Données rafraîchies!', 'success');
    };
const loadUsers = async () => {
    try {
        setIsLoading(true);
        
        const params = {};
        if (searchTerm) params.search = searchTerm;
        if (filterRole !== 'all') params.role = filterRole;
        if (filterStatus !== 'all') params.isActive = filterStatus === 'active';
        params.page = page;
        params.limit = limit;

        console.log('🔍 Loading users with params:', params);
        
        const response = await ApiService.getUsers(params);
        
        if (response.success) {
            setUsers(response.users);
            setTotalUsers(response.total);
            
            const stats = {
                total: response.total,
                active: response.users.filter(u => u.isActive).length,
                inactive: response.users.filter(u => !u.isActive).length,
                admins: response.users.filter(u => u.role === 'admin').length,
                managers: response.users.filter(u => u.role === 'manager').length,
                employees: response.users.filter(u => u.role === 'user' || u.role === 'employee').length
            };
            setUserStats(stats);
            console.log('Users loaded successfully:', response.users.length);
        } else {
            throw new Error(response.message || 'Failed to load users');
        }
    } catch (error) {
        console.error('Failed to load users:', error);
        
        if (error.message.includes('Authentication required') || error.message.includes('needsLogin')) {
            showNotification('Session expirée. Reconnectez-vous.', 'error');
            navigate('/login');
        } else {
            showNotification(error.message || 'Erreur lors du chargement des utilisateurs', 'error');
        }
        
        setUsers([]);
        setUserStats({
            total: 0,
            active: 0,
            inactive: 0,
            admins: 0,
            managers: 0,
            employees: 0
        });
    } finally {
        setIsLoading(false);
    }
};


const createUser = async (userData) => {
    try {
        setIsLoading(true);
        const response = await ApiService.createUser(userData);
        
        if (response.success) {
            showNotification('Utilisateur créé avec succès');
            setShowCreateModal(false);
            resetForm();
            loadUsers();
        } else {
            throw new Error(response.message || 'Failed to create user');
        }
    } catch (error) {
        console.error('Failed to create user:', error);
        showNotification(error.message || 'Erreur lors de la création', 'error');
    } finally {
        setIsLoading(false);
    }
};

    const updateUser = async (userId, userData) => {
    try {
        setIsLoading(true);
        const response = await ApiService.updateUser(userId, userData);
        
        if (response.success) {
            showNotification('Utilisateur mis à jour avec succès');
            setShowEditModal(false);
            setEditingUser(null);
            resetForm();
            loadUsers();
        } else {
            throw new Error(response.message || 'Failed to update user');
        }
    } catch (error) {
        console.error('Failed to update user:', error);
        showNotification(error.message || 'Erreur lors de la mise à jour', 'error');
    } finally {
        setIsLoading(false);
    }
};

const deleteUser = async (userId) => {
    try {
        setIsLoading(true);
        const response = await ApiService.deleteUser(userId);
        
        if (response.success) {
            showNotification('Utilisateur supprimé avec succès');
            setShowDeleteConfirm(false);
            setUserToDelete(null);
            loadUsers();
        } else {
            throw new Error(response.message || 'Failed to delete user');
        }
    } catch (error) {
        console.error('Failed to delete user:', error);
        showNotification(error.message || 'Erreur lors de la suppression', 'error');
    } finally {
        setIsLoading(false);
    }
};

const toggleUserStatus = async (userId, currentStatus) => {
    try {
        const response = await ApiService.toggleUserStatus(userId);
        
        if (response.success) {
            showNotification(`Utilisateur ${currentStatus ? 'désactivé' : 'activé'} avec succès`);
            loadUsers();
        } else {
            throw new Error(response.message || 'Failed to toggle user status');
        }
    } catch (error) {
        console.error('Failed to toggle user status:', error);
        showNotification('Erreur lors du changement de statut', 'error');
    }
};

    const showNotification = (message, type = 'success', duration = 4000) => {
        const id = Date.now() + Math.random();
        const notification = { id, message, type, duration };
        setNotifications(prev => [...prev, notification]);
        setTimeout(() => removeNotification(id), duration);
    };

    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(notif => notif.id !== id));
    };

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (passwordInput === ADMIN_PASSWORD) {
            setIsAuthenticated(true);
            setShowPasswordError(false);
            showNotification('Accès autorisé à la gestion des utilisateurs');
        } else {
            setShowPasswordError(true);
            setTimeout(() => setShowPasswordError(false), 3000);
        }
        setPasswordInput('');
    };

    const resetForm = () => {
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            password: '',
            role: 'user',
            department: '',
            position: '',
            phone: ''
        });
    };

    const handleCreateUser = () => {
        resetForm();
        setShowCreateModal(true);
    };

    const handleEditUser = (userData) => {
        setEditingUser(userData);
        setFormData({
            firstName: userData.firstName,
            lastName: userData.lastName,
            email: userData.email,
            password: '',
            role: userData.role,
            department: userData.profile?.department || '',
            position: userData.profile?.position || '',
            phone: userData.profile?.phone || ''
        });
        setShowEditModal(true);
    };

    const handleDeleteUser = (userData) => {
        setUserToDelete(userData);
        setShowDeleteConfirm(true);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        if (editingUser) {
            updateUser(editingUser._id, formData);
        } else {
            createUser(formData);
        }
    };

    const togglePasswordVisibility = (userId) => {
        setShowPasswords(prev => ({
            ...prev,
            [userId]: !prev[userId]
        }));
    };

    const getRoleBadge = (role) => {
        const roleMap = {
            'admin': { text: 'Admin', class: 'status-out-of-stock', color: '#dc2626' },
            'manager': { text: 'Manager', class: 'status-warning', color: '#f59e0b' },
            'user': { text: 'User', class: 'status-available', color: '#059669' },
            'employee': { text: 'Employee', class: 'status-low-stock', color: '#6b7280' }
        };
        return roleMap[role] || roleMap.user;
    };

    const getStatusBadge = (isActive) => {
        return isActive 
            ? { text: 'Actif', class: 'status-available', color: '#059669' }
            : { text: 'Inactif', class: 'status-out-of-stock', color: '#dc2626' };
    };

    const filteredUsers = users.filter(user => {
        const matchesSearch = searchTerm === '' || 
            user.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(searchTerm.toLowerCase());
        
        const matchesRole = filterRole === 'all' || user.role === filterRole;
        const matchesStatus = filterStatus === 'all' || 
            (filterStatus === 'active' && user.isActive) ||
            (filterStatus === 'inactive' && !user.isActive);
        
        return matchesSearch && matchesRole && matchesStatus;
    });



const menuItems = [
    { 
        id: 'barcoding', 
        label: 'Barcoding Database', 
        icon: FileText, // Keep as Lucide icon
        path: '/barcoding' 
    },
    { 
        id: 'mep-solutions', 
        label: 'MEP Solutions', 
        icon: MepIcon, // 🔄 Replace with image
        isImage: true,
        path: '/mep_solutions' 
    },
    { 
        id: 'architectural-solutions', 
        label: 'Architectural Solutions', 
        icon: architecturalIcon , // 🔄 Replace with image
        isImage: true,
        path: '/architectural_solutions' 
    },
    { 
        id: 'civil-solutions', 
        label: 'Civil Solutions', 
        icon: civilIcon, // 🔄 Replace with image
        isImage: true,
        path: '/civil_solutions' 
    },
    { 
        id: 'construction-chemicals', 
        label: 'Construction Chemicals', 
        icon: constructionIcon, // 🔄 Replace with image
        isImage: true,
        path: '/construction_chemicals' 
    },
    { 
        id: 'power-tools', 
        label: 'Power & Industrial Tools', 
        icon: powerToolsIcon, // 🔄 Replace with image
        isImage: true,
        path: '/power_tools' 
    },
    { 
        id: 'sustainable-solutions', 
        label: 'Sustainable Solutions', 
        icon: sustainableIcon, // 🔄 Replace with image
        isImage: true,
        path: '/sustainable_solutions' 
    },
    { 
        id: 'hygienic-solutions', 
        label: 'Hygienic Solutions', 
        icon: hygienicIcon, // 🔄 Replace with image
        isImage: true,
        path: '/hygienic_solutions' 
    },
    { 
        id: 'conversions', 
        label: 'Engineering Conversions', 
        icon: Calculator, // Keep as Lucide icon
        path: '/conversion' 
    },
    { 
        id: 'analytics', 
        label: 'Amazon Products', 
        icon: BarChart3, // Keep as Lucide icon
        path: '/amazon_products' 
    },
    { 
        id: 'team', 
        label: 'Team Management', 
        icon: Users, // Keep as Lucide icon
        path: '/team_management' 
    },
    { 
        id: 'user-management', 
        label: 'User Management', 
        icon: UserCog, // Keep as Lucide icon
        path: '/users_management' 
    },
];
    
    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if ((item.id === 'settings' || item.id === 'user-management') && user?.role !== 'admin') return false;
        return true;
    });

const handleLogout = async () => {
    if (window.confirm('Are you sure you wanna disconnect?')) {
        // Nettoyer les données utilisateur
        ApiService.clearUserData();
        
        // Utiliser React Router pour naviguer vers login
        navigate('/login');
    }
};

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const NotificationItem = ({ notification, onRemove }) => {
        const getNotificationStyle = (type) => {
            const baseStyle = {
                padding: '16px 20px',
                borderRadius: '12px',
                marginBottom: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1)',
                border: '1px solid',
                minWidth: '350px',
                maxWidth: '500px',
                position: 'relative',
                animation: 'slideInRight 0.3s ease-out',
                cursor: 'pointer'
            };

            const styles = {
                success: { ...baseStyle, backgroundColor: '#f0fdf4', borderColor: '#bbf7d0', color: '#166534' },
                error: { ...baseStyle, backgroundColor: '#fef2f2', borderColor: '#fecaca', color: '#dc2626' },
                warning: { ...baseStyle, backgroundColor: '#fffbeb', borderColor: '#fed7aa', color: '#d97706' },
                info: { ...baseStyle, backgroundColor: '#eff6ff', borderColor: '#bfdbfe', color: '#1d4ed8' }
            };

            return styles[type] || styles.info;
        };

        const getIcon = (type) => {
            const iconStyle = { width: '20px', height: '20px' };
            switch (type) {
                case 'success': return <CheckCircle style={iconStyle} />;
                case 'error': return <AlertCircle style={iconStyle} />;
                case 'warning': return <AlertCircle style={iconStyle} />;
                default: return <Bell style={iconStyle} />;
            }
        };

        return (
            <div 
                style={getNotificationStyle(notification.type)}
                onClick={() => onRemove(notification.id)}
            >
                {getIcon(notification.type)}
                <div style={{ flex: 1 }}>
                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                        {notification.message}
                    </p>
                </div>
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onRemove(notification.id);
                    }}
                    style={{
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: '4px',
                        borderRadius: '4px',
                        opacity: 0.7
                    }}
                >
                    <X style={{ width: '16px', height: '16px' }} />
                </button>
            </div>
        );
    };

    if (!user) {
        return (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Chargement...</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return (
            <div style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px'
            }}>
                <div style={{
                    background: 'white',
                    borderRadius: '16px',
                    padding: '40px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                    maxWidth: '400px',
                    width: '100%'
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px'
                        }}>
                            <Lock style={{ width: '40px', height: '40px', color: 'white' }} />
                        </div>
                        <h1 style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#1f2937' }}>
                            Accès Sécurisé
                        </h1>
                        <p style={{ margin: '8px 0 0', color: '#6b7280', fontSize: '16px' }}>
                            Gestion des Utilisateurs
                        </p>
                    </div>

                    <form onSubmit={handlePasswordSubmit}>
                        <div style={{ marginBottom: '24px' }}>
                            <label style={{ 
                                display: 'block', 
                                fontSize: '14px', 
                                fontWeight: '500', 
                                color: '#374151',
                                marginBottom: '8px'
                            }}>
                                Mot de passe administrateur
                            </label>
                            <div style={{ position: 'relative' }}>
                                <input
                                    type="password"
                                    value={passwordInput}
                                    onChange={(e) => setPasswordInput(e.target.value)}
                                    placeholder="Entrez le mot de passe"
                                    style={{
                                        width: '100%',
                                        padding: '12px 16px',
                                        border: showPasswordError ? '2px solid #dc2626' : '1px solid #d1d5db',
                                        borderRadius: '8px',
                                        fontSize: '16px',
                                        outline: 'none',
                                        transition: 'border-color 0.2s',
                                        boxSizing: 'border-box'
                                    }}
                                    required
                                />
                                <Key style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    width: '20px',
                                    height: '20px',
                                    color: '#9ca3af'
                                }} />
                            </div>
                            {showPasswordError && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    marginTop: '8px',
                                    color: '#dc2626',
                                    fontSize: '14px'
                                }}>
                                    <AlertTriangle style={{ width: '16px', height: '16px' }} />
                                    Mot de passe incorrect
                                </div>
                            )}
                        </div>

                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '12px',
                                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                                color: 'white',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '16px',
                                fontWeight: '600',
                                cursor: 'pointer',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                transition: 'transform 0.2s',
                            }}
                            onMouseEnter={(e) => e.target.style.transform = 'translateY(-1px)'}
                            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                        >
                            <Unlock style={{ width: '20px', height: '20px' }} />
                            Accéder
                        </button>
                    </form>

                    <div style={{
                        marginTop: '24px',
                        padding: '16px',
                        backgroundColor: '#f3f4f6',
                        borderRadius: '8px',
                        textAlign: 'center'
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '8px' }}>
                            <Shield style={{ width: '16px', height: '16px', color: '#059669' }} />
                            <span style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                                Zone Sécurisée
                            </span>
                        </div>
                        <p style={{ margin: 0, fontSize: '12px', color: '#6b7280' }}>
                            Cette page permet de gérer les comptes utilisateurs.
                            Accès réservé aux administrateurs uniquement.
                        </p>
                    </div>

                    <button
                        onClick={() => navigate('/dashboard')}
                        style={{
                            width: '100%',
                            marginTop: '16px',
                            padding: '8px',
                            background: 'transparent',
                            color: '#6b7280',
                            border: '1px solid #d1d5db',
                            borderRadius: '8px',
                            fontSize: '14px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '8px'
                        }}
                    >
                        <ArrowLeft style={{ width: '16px', height: '16px' }} />
                        Retour au Dashboard
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard-container">
            {/* Sidebar */}
            <aside className="sidebar">
                    <div className="sidebar-header">
                        <div 
                            className="sidebar-logo-container"
                            onClick={() => navigate('/dashboard')}
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                borderRadius: '8px',
                                padding: '8px'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                e.currentTarget.style.transform = 'scale(1.02)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                                e.currentTarget.style.transform = 'scale(1)';
                            }}
                            title="Retour au Dashboard"
                        >
                            <div className="sidebar-logo">
                                <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                            </div>
                            <div className="sidebar-brand">
                                <h1 className="sidebar-title">UNITECH IKK</h1>
                                <p className="sidebar-subtitle">Enterprise Dashboard</p>
                            </div>
                        </div>
                    </div>

<nav className="sidebar-nav">
  {filteredMenuItems.map((item) => (
    <div
      key={item.id}
      className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
      onClick={() => {
        setActiveMenuItem(item.id);
        navigate(item.path);
      }}
    >
      {item.isImage ? (
        <img 
          src={item.icon} 
          alt={item.label}
          className="nav-icon-image"
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures proper alignment
          }}
        />
      ) : (
        <item.icon 
          style={{ 
            width: '20px', 
            height: '20px',
            display: 'block' // Ensures consistency with images
          }} 
        />
      )}
      <span className="nav-text">{item.label}</span>
    </div>
  ))}
</nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <UsersIcon style={{ width: '16px', height: '16px' }} />
                                    <span>User Management</span>
                                </div>
                            </nav>
                        </div>

                    <div className="header-right">
                        <div className="search-container">
                            <input
                                type="text"
                                className="search-input"
                                placeholder="Rechercher..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                        </div>

                        <div className="header-actions">
                            <button
                                className="header-button"
                                onClick={handleRefresh}
                                disabled={isLoading}
                                title="Actualiser"
                            >
                                <RefreshCw style={{
                                    width: '18px',
                                    height: '18px',
                                    transform: isLoading ? 'rotate(360deg)' : 'none',
                                    transition: 'transform 1s linear'
                                }} />
                            </button>

                            <button 
                                className="header-button"
                                title="Notifications"
                            >
                                <Bell style={{ width: '18px', height: '18px' }} />
                                {notifications.length > 0 && (
                                    <span className="notification-badge">{notifications.length}</span>
                                )}
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/settings')}
                                title="Paramètres système"
                            >
                                <Settings style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/project_management')}
                                title="Gestion de projets"
                            >
                                <Folder style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/technical_support')}
                                title="Technical Support"
                            >
                                <MonitorCog style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/admin_support_it')}
                                title="Admin Support IT"
                            >
                                <SquareActivity style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/mytickets')}
                                title="My Tickets"
                            >
                                <Tickets style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/quotations')}
                                title="Quotation System"
                            >
                                <Receipt style={{ width: '18px', height: '18px' }} />
                            </button>

                            <button
                                className="header-button"
                                onClick={() => navigate('/clients')}
                                title="Clients"
                            >
                                <Briefcase style={{ width: '18px', height: '18px' }} />
                            </button>

                            <div className="time-display">
                                {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                            </div>
                        </div>
                    </div>
                    </div>
                </header>

                {/* User Management Content */}
                <div className="products-content">
                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Gestion des Utilisateurs 👤</h1>
                        <p className="page-subtitle">
                            Créez, modifiez et gérez les comptes utilisateurs du système.
                        </p>

                        <div className="page-actions">
                            <button 
                                className="action-button secondary"
                                onClick={() => window.print()}
                            >
                                <Download style={{ width: '16px', height: '16px' }} />
                                Exporter
                            </button>
                            <button 
                                className="action-button primary"
                                onClick={handleCreateUser}
                            >
                                <UserPlus style={{ width: '16px', height: '16px' }} />
                                Nouvel Utilisateur
                            </button>
                        </div>
                    </div>

                    {/* Stats Cards */}
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '30px' }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                            padding: '24px', borderRadius: '12px', color: 'white'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '500', opacity: 0.9 }}>Total Utilisateurs</h3>
                                    <p style={{ margin: 0, fontSize: '32px', fontWeight: '700' }}>{userStats.total}</p>
                                </div>
                                <UsersIcon style={{ width: '40px', height: '40px', opacity: 0.8 }} />
                            </div>
                            <div style={{ fontSize: '14px', opacity: 0.8 }}>
                                Tous comptes confondus
                            </div>
                        </div>

                        <div style={{
                            background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)',
                            padding: '24px', borderRadius: '12px', color: 'white'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '500', opacity: 0.9 }}>Utilisateurs Actifs</h3>
                                    <p style={{ margin: 0, fontSize: '32px', fontWeight: '700' }}>{userStats.active}</p>
                                </div>
                                <UserCheck style={{ width: '40px', height: '40px', opacity: 0.8 }} />
                            </div>
                            <div style={{ fontSize: '14px', opacity: 0.8 }}>
                                Comptes activés
                            </div>
                        </div>

                        <div style={{
                            background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                            padding: '24px', borderRadius: '12px', color: 'white'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '500', opacity: 0.9 }}>Administrateurs</h3>
                                    <p style={{ margin: 0, fontSize: '32px', fontWeight: '700' }}>{userStats.admins}</p>
                                </div>
                                <Shield style={{ width: '40px', height: '40px', opacity: 0.8 }} />
                            </div>
                            <div style={{ fontSize: '14px', opacity: 0.8 }}>
                                Accès privilégié
                            </div>
                        </div>

                        <div style={{
                            background: 'linear-gradient(135deg, #f59e0b 0%, #fbbf24 100%)',
                            padding: '24px', borderRadius: '12px', color: 'white'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '16px' }}>
                                <div>
                                    <h3 style={{ margin: 0, fontSize: '14px', fontWeight: '500', opacity: 0.9 }}>Managers</h3>
                                    <p style={{ margin: 0, fontSize: '32px', fontWeight: '700' }}>{userStats.managers}</p>
                                </div>
                                <Award style={{ width: '40px', height: '40px', opacity: 0.8 }} />
                            </div>
                            <div style={{ fontSize: '14px', opacity: 0.8 }}>
                                Rôle de gestion
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">
                                    <Search style={{ width: '16px', height: '16px' }} />
                                    Rechercher
                                </label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Nom, email..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Rôle</label>
                                <select
                                    className="filter-select"
                                    value={filterRole}
                                    onChange={(e) => setFilterRole(e.target.value)}
                                >
                                    <option value="all">Tous les rôles</option>
                                    <option value="admin">Administrateurs</option>
                                    <option value="manager">Managers</option>
                                    <option value="user">Utilisateurs</option>
                                    <option value="employee">Employés</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Statut</label>
                                <select
                                    className="filter-select"
                                    value={filterStatus}
                                    onChange={(e) => setFilterStatus(e.target.value)}
                                >
                                    <option value="all">Tous les statuts</option>
                                    <option value="active">Actifs</option>
                                    <option value="inactive">Inactifs</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Users Table */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                Liste des Utilisateurs
                            </h2>
                            <span className="table-stats">
                                {filteredUsers.length} utilisateur{filteredUsers.length > 1 ? 's' : ''}
                            </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                                <tr>
                                    <th>Utilisateur</th>
                                    <th>Email</th>
                                    <th>Rôle</th>
                                    <th>Département</th>
                                    <th>Mot de passe</th>
                                    <th>Statut</th>
                                    <th>Dernière connexion</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {filteredUsers.map((userData) => {
                                    const role = getRoleBadge(userData.role);
                                    const status = getStatusBadge(userData.isActive);
                                    
                                    return (
                                        <tr key={userData._id}>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                                    <div style={{
                                                        width: '40px', height: '40px', 
                                                        background: userData.isActive ? 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)' : 'linear-gradient(135deg, #6b7280 0%, #9ca3af 100%)',
                                                        borderRadius: '50%', display: 'flex', alignItems: 'center', 
                                                        justifyContent: 'center', color: 'white', fontSize: '14px', fontWeight: '600'
                                                    }}>
                                                        {userData.firstName?.charAt(0)}{userData.lastName?.charAt(0)}
                                                    </div>
                                                    <div>
                                                        <div className="product-name" style={{ fontWeight: '600' }}>
                                                            {userData.firstName} {userData.lastName}
                                                        </div>
                                                        <div className="product-sku" style={{ fontSize: '12px', color: '#6b7280' }}>
                                                            ID: {userData._id.slice(-6)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    <Mail style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                                    <span style={{ fontSize: '14px' }}>{userData.email}</span>
                                                </div>
                                            </td>
                                            <td>
                                                <span 
                                                    className={`status-badge ${role.class}`}
                                                    style={{
                                                        backgroundColor: role.color + '20',
                                                        color: role.color,
                                                        border: `1px solid ${role.color}40`
                                                    }}
                                                >
                                                    {role.text}
                                                </span>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                                    {userData.profile?.department ? (
                                                        <>
                                                            <Briefcase style={{ width: '16px', height: '16px', color: '#6b7280' }} />
                                                            <div>
                                                                <div style={{ fontSize: '14px', fontWeight: '500' }}>
                                                                    {userData.profile.department}
                                                                </div>
                                                                {userData.profile?.position && (
                                                                    <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                                                        {userData.profile.position}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <span style={{ fontSize: '14px', color: '#9ca3af' }}>Non défini</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{ 
                                                        fontSize: '14px', 
                                                        fontFamily: 'monospace',
                                                        backgroundColor: '#f3f4f6',
                                                        padding: '4px 8px',
                                                        borderRadius: '4px',
                                                        minWidth: '80px'
                                                    }}>
                                                        {showPasswords[userData._id] ? '••••••••' : '••••••••'}
                                                    </span>
                                                    <button
                                                        className="action-icon"
                                                        onClick={() => togglePasswordVisibility(userData._id)}
                                                        title={showPasswords[userData._id] ? 'Masquer' : 'Afficher'}
                                                    >
                                                        {showPasswords[userData._id] ? 
                                                            <EyeOff style={{ width: '14px', height: '14px' }} /> :
                                                            <Eye style={{ width: '14px', height: '14px' }} />
                                                        }
                                                    </button>
                                                </div>
                                            </td>
                                            <td>
                                                <span 
                                                    className={`status-badge ${status.class}`}
                                                    style={{
                                                        backgroundColor: status.color + '20',
                                                        color: status.color,
                                                        border: `1px solid ${status.color}40`
                                                    }}
                                                >
                                                    {status.text}
                                                </span>
                                            </td>
                                            <td>
                                                <div>
                                                    {userData.lastLogin ? (
                                                        <>
                                                            <div style={{ fontSize: '14px', fontWeight: '500' }}>
                                                                {new Date(userData.lastLogin).toLocaleDateString('fr-FR')}
                                                            </div>
                                                            <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                                                {new Date(userData.lastLogin).toLocaleTimeString('fr-FR', { 
                                                                    hour: '2-digit', 
                                                                    minute: '2-digit' 
                                                                })}
                                                            </div>
                                                        </>
                                                    ) : (
                                                        <span style={{ fontSize: '14px', color: '#9ca3af' }}>Jamais connecté</span>
                                                    )}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="actions-cell">
                                                    <button 
                                                        className="action-icon" 
                                                        title="Modifier"
                                                        onClick={() => handleEditUser(userData)}
                                                    >
                                                        <Edit style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                    <button 
                                                        className="action-icon" 
                                                        title={userData.isActive ? 'Désactiver' : 'Activer'}
                                                        onClick={() => toggleUserStatus(userData._id, userData.isActive)}
                                                        style={{ 
                                                            color: userData.isActive ? '#dc2626' : '#059669' 
                                                        }}
                                                    >
                                                        {userData.isActive ? 
                                                            <UserX style={{ width: '16px', height: '16px' }} /> :
                                                            <UserCheck style={{ width: '16px', height: '16px' }} />
                                                        }
                                                    </button>
                                                    <button 
                                                        className="action-icon" 
                                                        title="Supprimer"
                                                        onClick={() => handleDeleteUser(userData)}
                                                        style={{ color: '#dc2626' }}
                                                    >
                                                        <Trash2 style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>

                            {filteredUsers.length === 0 && !isLoading && (
                                <div style={{ 
                                    padding: '40px', 
                                    textAlign: 'center', 
                                    color: '#64748b'
                                }}>
                                    <UsersIcon style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                    <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                        {users.length === 0 ? 'Routes backend manquantes' : 'Aucun utilisateur trouvé'}
                                    </p>
                                    <p style={{ fontSize: '14px', marginBottom: '16px' }}>
                                        {users.length === 0 
                                            ? 'Ajoutez les routes /api/users dans votre server.js pour charger les données.'
                                            : searchTerm || filterRole !== 'all' || filterStatus !== 'all' 
                                                ? 'Aucun utilisateur ne correspond aux critères de recherche.'
                                                : 'Commencez par créer votre premier utilisateur.'
                                        }
                                    </p>
                                    {users.length === 0 && (
                                        <div style={{
                                            background: '#f0f9ff',
                                            border: '1px solid #bae6fd',
                                            borderRadius: '8px',
                                            padding: '16px',
                                            textAlign: 'left',
                                            marginTop: '20px'
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                                <AlertTriangle style={{ width: '20px', height: '20px', color: '#0369a1' }} />
                                                <strong style={{ color: '#0369a1', fontSize: '14px' }}>Instructions Backend</strong>
                                            </div>
                                            <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#0369a1' }}>
                                                1. Ajoutez les routes utilisateurs dans votre server.js
                                            </p>
                                            <p style={{ margin: '0 0 8px', fontSize: '13px', color: '#0369a1' }}>
                                                2. Redémarrez votre serveur Node.js
                                            </p>
                                            <p style={{ margin: '0', fontSize: '13px', color: '#0369a1' }}>
                                                3. Actualisez cette page
                                            </p>
                                        </div>
                                    )}
                                </div>
                            )}

                            {isLoading && (
                                <div style={{ 
                                    padding: '40px', 
                                    textAlign: 'center', 
                                    color: '#64748b'
                                }}>
                                    <RefreshCw style={{ 
                                        width: '32px', 
                                        height: '32px', 
                                        margin: '0 auto 16px', 
                                        animation: 'spin 1s linear infinite' 
                                    }} />
                                    <p style={{ fontSize: '16px', fontWeight: '500' }}>
                                        Chargement des utilisateurs...
                                    </p>
                                </div>
                            )}
                    </div>
                </div>

                {/* Create/Edit User Modal */}
                {(showCreateModal || showEditModal) && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '20px'
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            width: '100%',
                            maxWidth: '600px',
                            maxHeight: '90vh',
                            overflow: 'auto',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}>
                            <div style={{
                                padding: '24px 32px',
                                borderBottom: '1px solid #e5e7eb',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#1f2937' }}>
                                        {editingUser ? 'Modifier l\'utilisateur' : 'Nouvel utilisateur'}
                                    </h2>
                                    <p style={{ margin: '4px 0 0', color: '#6b7280', fontSize: '14px' }}>
                                        {editingUser ? 'Modifiez les informations de l\'utilisateur' : 'Créez un nouveau compte utilisateur'}
                                    </p>
                                </div>
                                <button
                                    onClick={() => {
                                        setShowCreateModal(false);
                                        setShowEditModal(false);
                                        setEditingUser(null);
                                        resetForm();
                                    }}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        padding: '8px',
                                        borderRadius: '8px',
                                        cursor: 'pointer',
                                        color: '#6b7280'
                                    }}
                                >
                                    <X style={{ width: '20px', height: '20px' }} />
                                </button>
                            </div>

                            <form onSubmit={handleFormSubmit} style={{ padding: '32px' }}>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginBottom: '24px' }}>
                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontSize: '14px', 
                                            fontWeight: '500', 
                                            color: '#374151',
                                            marginBottom: '8px'
                                        }}>
                                            Prénom *
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.firstName}
                                            onChange={(e) => setFormData({...formData, firstName: e.target.value})}
                                            placeholder="John"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontSize: '14px', 
                                            fontWeight: '500', 
                                            color: '#374151',
                                            marginBottom: '8px'
                                        }}>
                                            Nom *
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.lastName}
                                            onChange={(e) => setFormData({...formData, lastName: e.target.value})}
                                            placeholder="Doe"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                <div style={{ marginBottom: '24px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        fontSize: '14px', 
                                        fontWeight: '500', 
                                        color: '#374151',
                                        marginBottom: '8px'
                                    }}>
                                        Email *
                                    </label>
                                    <input
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                                        placeholder="john.doe@unitech.com"
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '12px 16px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            outline: 'none',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginBottom: '24px' }}>
                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontSize: '14px', 
                                            fontWeight: '500', 
                                            color: '#374151',
                                            marginBottom: '8px'
                                        }}>
                                            {editingUser ? 'Nouveau mot de passe' : 'Mot de passe *'}
                                        </label>
                                        <input
                                            type="password"
                                            value={formData.password}
                                            onChange={(e) => setFormData({...formData, password: e.target.value})}
                                            placeholder={editingUser ? 'Laisser vide pour ne pas changer' : 'Mot de passe'}
                                            required={!editingUser}
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontSize: '14px', 
                                            fontWeight: '500', 
                                            color: '#374151',
                                            marginBottom: '8px'
                                        }}>
                                            Rôle *
                                        </label>
                                        <select
                                            value={formData.role}
                                            onChange={(e) => setFormData({...formData, role: e.target.value})}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box',
                                                backgroundColor: 'white'
                                            }}
                                        >
                                            <option value="user">Utilisateur</option>
                                            <option value="employee">Employé</option>
                                            <option value="manager">Manager</option>
                                            <option value="admin">Administrateur</option>
                                        </select>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginBottom: '24px' }}>
                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontSize: '14px', 
                                            fontWeight: '500', 
                                            color: '#374151',
                                            marginBottom: '8px'
                                        }}>
                                            Département
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.department}
                                            onChange={(e) => setFormData({...formData, department: e.target.value})}
                                            placeholder="Engineering, Marketing..."
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ 
                                            display: 'block', 
                                            fontSize: '14px', 
                                            fontWeight: '500', 
                                            color: '#374151',
                                            marginBottom: '8px'
                                        }}>
                                            Poste
                                        </label>
                                        <input
                                            type="text"
                                            value={formData.position}
                                            onChange={(e) => setFormData({...formData, position: e.target.value})}
                                            placeholder="Project Manager, Developer..."
                                            style={{
                                                width: '100%',
                                                padding: '12px 16px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                outline: 'none',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                <div style={{ marginBottom: '32px' }}>
                                    <label style={{ 
                                        display: 'block', 
                                        fontSize: '14px', 
                                        fontWeight: '500', 
                                        color: '#374151',
                                        marginBottom: '8px'
                                    }}>
                                        Téléphone
                                    </label>
                                    <input
                                        type="tel"
                                        value={formData.phone}
                                        onChange={(e) => setFormData({...formData, phone: e.target.value})}
                                        placeholder="+33 6 12 34 56 78"
                                        style={{
                                            width: '100%',
                                            padding: '12px 16px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            outline: 'none',
                                            boxSizing: 'border-box'
                                        }}
                                    />
                                </div>

                                <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setShowCreateModal(false);
                                            setShowEditModal(false);
                                            setEditingUser(null);
                                            resetForm();
                                        }}
                                        style={{
                                            padding: '12px 24px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            backgroundColor: 'white',
                                            color: '#374151'
                                        }}
                                    >
                                        Annuler
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        style={{
                                            padding: '12px 24px',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                            backgroundColor: '#1e40af',
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            opacity: isLoading ? 0.7 : 1
                                        }}
                                    >
                                        {isLoading ? (
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                        ) : (
                                            <Save style={{ width: '16px', height: '16px' }} />
                                        )}
                                        {editingUser ? 'Mettre à jour' : 'Créer'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}

                {/* Delete Confirmation Modal */}
                {showDeleteConfirm && userToDelete && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                        padding: '20px'
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            borderRadius: '16px',
                            width: '100%',
                            maxWidth: '400px',
                            boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
                        }}>
                            <div style={{ padding: '32px', textAlign: 'center' }}>
                                <div style={{
                                    width: '80px',
                                    height: '80px',
                                    backgroundColor: '#fef2f2',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    margin: '0 auto 24px'
                                }}>
                                    <AlertTriangle style={{ width: '40px', height: '40px', color: '#dc2626' }} />
                                </div>

                                <h3 style={{ margin: '0 0 16px', fontSize: '18px', fontWeight: '600', color: '#1f2937' }}>
                                    Supprimer l'utilisateur
                                </h3>
                                
                                <p style={{ margin: '0 0 24px', color: '#6b7280', fontSize: '14px', lineHeight: '1.5' }}>
                                    Êtes-vous sûr de vouloir supprimer <strong>{userToDelete.firstName} {userToDelete.lastName}</strong> ?
                                    Cette action est irréversible.
                                </p>

                                <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                                    <button
                                        onClick={() => {
                                            setShowDeleteConfirm(false);
                                            setUserToDelete(null);
                                        }}
                                        style={{
                                            padding: '12px 24px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            cursor: 'pointer',
                                            backgroundColor: 'white',
                                            color: '#374151'
                                        }}
                                    >
                                        Annuler
                                    </button>
                                    <button
                                        onClick={() => deleteUser(userToDelete._id)}
                                        disabled={isLoading}
                                        style={{
                                            padding: '12px 24px',
                                            border: 'none',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                            backgroundColor: '#dc2626',
                                            color: 'white',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px',
                                            opacity: isLoading ? 0.7 : 1
                                        }}
                                    >
                                        {isLoading ? (
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                        ) : (
                                            <Trash2 style={{ width: '16px', height: '16px' }} />
                                        )}
                                        Supprimer
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>

            {/* Notifications Container */}
            {notifications.length > 0 && (
                <div style={{
                    position: 'fixed',
                    top: '20px',
                    right: '20px',
                    zIndex: 9999,
                    pointerEvents: 'none'
                }}>
                    <div style={{ pointerEvents: 'auto' }}>
                        {notifications.map(notification => (
                            <NotificationItem
                                key={notification.id}
                                notification={notification}
                                onRemove={removeNotification}
                            />
                        ))}
                    </div>
                </div>
            )}

            {/* CSS for animations */}
            <style>
                {`
                    @keyframes slideInRight {
                        from {
                            transform: translateX(100%);
                            opacity: 0;
                        }
                        to {
                            transform: translateX(0);
                            opacity: 1;
                        }
                    }

                    @keyframes spin {
                        from {
                            transform: rotate(0deg);
                        }
                        to {
                            transform: rotate(360deg);
                        }
                    }

                    .products-table td {
                        vertical-align: middle;
                    }

                    .action-icon:hover {
                        background-color: #f3f4f6;
                        transform: scale(1.1);
                    }

                    .filter-input:focus,
                    .filter-select:focus {
                        border-color: #1e40af;
                        box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1);
                    }

                    .status-badge {
                        font-size: 12px;
                        font-weight: 500;
                        padding: 4px 12px;
                        border-radius: 20px;
                        text-transform: uppercase;
                        letter-spacing: 0.5px;
                    }

                    .table-head th {
                        font-weight: 600;
                        text-transform: uppercase;
                        font-size: 12px;
                        letter-spacing: 0.5px;
                        color: #6b7280;
                        padding: 16px 12px;
                    }

                    .table-body tr:hover {
                        background-color: #f9fafb;
                    }

                    .actions-cell {
                        display: flex;
                        gap: 8px;
                        align-items: center;
                    }

                    .action-icon {
                        padding: 8px;
                        border: none;
                        background: none;
                        border-radius: 6px;
                        cursor: pointer;
                        transition: all 0.2s;
                        color: #6b7280;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }

                    .nav-item {
                        cursor: pointer;
                        transition: all 0.2s;
                    }

                    .nav-item:hover {
                        background-color: rgba(255, 255, 255, 0.1);
                    }

                    .nav-item.active {
                        background-color: rgba(255, 255, 255, 0.15);
                        border-left: 3px solid #60a5fa;
                    }

                    .page-actions .action-button {
                        display: flex;
                        align-items: center;
                        gap: 8px;
                        padding: 12px 20px;
                        border-radius: 8px;
                        font-weight: 500;
                        font-size: 14px;
                        cursor: pointer;
                        transition: all 0.2s;
                        border: none;
                    }

                    .action-button.primary {
                        background: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
                        color: white;
                    }

                    .action-button.primary:hover {
                        transform: translateY(-1px);
                        box-shadow: 0 4px 12px rgba(30, 64, 175, 0.3);
                    }

                    .action-button.secondary {
                        background: white;
                        color: #374151;
                        border: 1px solid #d1d5db;
                    }

                    .action-button.secondary:hover {
                        background-color: #f9fafb;
                        transform: translateY(-1px);
                    }

                    .filters-section {
                        margin-bottom: 24px;
                        padding: 20px;
                        background: white;
                        border-radius: 12px;
                        border: 1px solid #e5e7eb;
                    }

                    .filters-row {
                        display: flex;
                        gap: 20px;
                        align-items: end;
                        flex-wrap: wrap;
                    }

                    .filter-group {
                        display: flex;
                        flex-direction: column;
                        gap: 6px;
                        min-width: 200px;
                    }

                    .filter-label {
                        font-size: 14px;
                        font-weight: 500;
                        color: #374151;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }

                    .filter-input,
                    .filter-select {
                        padding: 10px 14px;
                        border: 1px solid #d1d5db;
                        border-radius: 8px;
                        font-size: 14px;
                        outline: none;
                        transition: border-color 0.2s;
                        background: white;
                    }

                    .products-table-section {
                        background: white;
                        border-radius: 12px;
                        border: 1px solid #e5e7eb;
                        overflow: hidden;
                    }

                    .table-header {
                        padding: 20px 24px;
                        border-bottom: 1px solid #e5e7eb;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }

                    .table-title {
                        margin: 0;
                        font-size: 18px;
                        font-weight: 600;
                        color: #1f2937;
                    }

                    .table-stats {
                        font-size: 14px;
                        color: #6b7280;
                    }

                    .products-table {
                        width: 100%;
                        border-collapse: collapse;
                    }

                    .products-table th,
                    .products-table td {
                        padding: 12px;
                        text-align: left;
                        border-bottom: 1px solid #f3f4f6;
                    }

                    .product-name {
                        font-size: 14px;
                        color: #1f2937;
                    }

                    .product-sku {
                        font-size: 12px;
                        color: #6b7280;
                    }
                `}
            </style>
        </div>
    );
};

export default UserManagementPage;